import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=59075948&scoped=true&"
import script from "./CourseDetail.vue?vue&type=script&lang=js&"
export * from "./CourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CourseDetail.vue?vue&type=style&index=1&id=59075948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59075948",
  null
  
)

export default component.exports